import { Service } from "./service"

export const PaymentTransactionsListingService = Service


// WEBPACK FOOTER //
// ./src/state/listing/payment-transactions/service/index.ts